var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.uploadList, function (item) {
        return _c(
          "div",
          { staticClass: "demo-upload-list" },
          [
            item.status === "finished"
              ? [
                  item.url.substring(item.url.length - 3, item.url.length) !=
                  "mp4"
                    ? _c("img", { attrs: { src: item.url } })
                    : _vm._e(),
                  item.url.substring(item.url.length - 3, item.url.length) ==
                  "mp4"
                    ? _c("video", {
                        attrs: { src: item.url, controls: "", autoplay: "" },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "demo-upload-list-cover" },
                    [
                      _c("Icon", {
                        attrs: { type: "ios-eye-outline" },
                        nativeOn: {
                          click: function ($event) {
                            _vm.handleView(
                              item,
                              item.url.substring(
                                item.url.length - 3,
                                item.url.length
                              ) == "mp4"
                            )
                          },
                        },
                      }),
                      _c("Icon", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.mode !== "detail",
                            expression: "mode !== 'detail'",
                          },
                        ],
                        attrs: { type: "ios-trash-outline" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleRemove(item)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : [
                  item.showProgress
                    ? _c("Progress", {
                        attrs: { percent: item.percentage, "hide-info": "" },
                      })
                    : _vm._e(),
                ],
          ],
          2
        )
      }),
      _c(
        "Upload",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mode !== "detail",
              expression: "mode !== 'detail'",
            },
          ],
          ref: "upload",
          staticStyle: { display: "inline", width: "58px", float: "left" },
          attrs: {
            "show-upload-list": false,
            "default-file-list": _vm.defaultList,
            "on-success": _vm.handleUploadFileSuccess,
            format: ["jpg", "jpeg", "png", "mp4"],
            "on-format-error": _vm.handleFormatError,
            "before-upload": _vm.beforeFileUpload,
            data: _vm.uploadParams,
            multiple: "",
            type: "drag",
            action: _vm.action,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "58px",
                height: "58px",
                "line-height": "58px",
              },
            },
            [_c("Icon", { attrs: { type: "md-add", size: "20" } })],
            1
          ),
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { title: _vm.imgName },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _vm.visible && !_vm.isVideo
            ? _c("img", {
                staticStyle: { width: "100%" },
                attrs: { src: _vm.imgUrl },
              })
            : _vm._e(),
          _vm.isVideo
            ? _c("video", {
                staticStyle: { width: "488px" },
                attrs: { src: _vm.imgUrl, controls: "", autoplay: "" },
              })
            : _vm._e(),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }